import React from 'react';
import { Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CalendarIcon from '../CustomSVGIcons/CalendarIcon';
import { GpsFixedOutlined, Payments } from '@mui/icons-material';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import { formatDateWithTimezone } from '../../utils/AppUtils';

export interface IEventDetails {
    event: IEvent;
}

const EventDetails: React.FC<IEventDetails> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack>
            <Stack mt={2} mb={4}>
                <TextWithIcon
                    icon={<CalendarIcon fill={theme[themeStyle].tag_white} height={'20px'} width={'20px'} />}
                    text=" Dates & Location"
                />
                <Typography
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 14, color: theme[themeStyle].tag_white }}>
                    {formatDateWithTimezone(event.event_start_date, event.timezone)}
                </Typography>
            </Stack>
            <Stack mb={4}>
                <TextWithIcon
                    icon={<GpsFixedOutlined sx={{ fontSize: 24, color: theme[themeStyle].tag_white }} />}
                    text="Location"
                />

                <Typography
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 14, color: theme[themeStyle].tag_white }}>
                    {event.location.description}
                </Typography>
            </Stack>

            <Stack mb={4}>
                <TextWithIcon
                    icon={<Payments sx={{ fontSize: 24, color: theme[themeStyle].tag_white }} />}
                    text="Refund Policy"
                />

                <Typography
                    style={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 14,
                        color: theme[themeStyle].tag_white,
                        textTransform: 'capitalize',
                    }}>
                    {event.refund_policy}
                </Typography>
                <Typography
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 14, color: theme[themeStyle].tag_white }}>
                    Thspian's fee is nonrefundable.
                </Typography>
            </Stack>
        </Stack>
    );
};

export { EventDetails };
